import { render, staticRenderFns } from "./CustomerOrdersEdit.vue?vue&type=template&id=4d5798d9&"
import script from "./CustomerOrdersEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrdersEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports